import { createMemoStyles } from '@wds/utils';
import { BETWEEN_MD_LG_MEDIA_QUERY, MD_MEDIA_QUERY } from '~shared/media-query';
import { PricingAppTheme, PackageTheme } from '~app/styles/pricing/types';
import { Packages } from '~shared/constants/pricing';

type Props = {
  packageName: Packages;
};

type RuleNames = 'PackageFooterCTA' | 'PricingPackageContainer' | 'PricingPackage' | 'Highlighted' | 'PlanFeaturesLink';

export const HIGHLIGHT = (defaultColor: string, packageTheme: PackageTheme): object => ({
  border: ({ packageName }: Props) =>
    `2px solid ${packageTheme[packageName] ? packageTheme[packageName].primary : defaultColor}`,
});

export default createMemoStyles<RuleNames, Props, PricingAppTheme>(
  ({ spacing, pricingPalette, packageTheme }: PricingAppTheme) => ({
    PricingPackageContainer: {
      marginBottom: spacing[4],
      width: '100%',
      maxWidth: 345,

      [MD_MEDIA_QUERY]: {
        display: 'flex',
        flexDirection: 'column',

        '&:last-of-type $PricingPackage': {
          borderRight: `1px solid ${pricingPalette.colors.flint}`,
        },

        '&:has(> $Highlighted) + $PricingPackageContainer $PricingPackage': {
          borderLeft: 'none',
        },
      },
    },

    PricingPackage: {
      position: 'relative',
      padding: [0, 0, spacing[5]],
      border: `1px solid ${pricingPalette.colors.flint}`,
      marginBottom: spacing[6],

      '& + div': {
        display: 'none',
      },

      [MD_MEDIA_QUERY]: {
        height: '100%',
        transition: 'border-color 0.5s ease',
        borderRight: 'none',

        '& + div': {
          display: 'inherit',
        },
      },

      [BETWEEN_MD_LG_MEDIA_QUERY]: {
        '& [class*=FeatureItem]': {
          paddingLeft: spacing[3],
          paddingRight: spacing[5],
        },
      },
    },

    Highlighted: {
      marginTop: 28,

      '& header': {
        paddingTop: spacing[5] - 1,
      },

      [MD_MEDIA_QUERY]: {
        marginTop: 0,
        ...HIGHLIGHT(pricingPalette.colors.flint, packageTheme),
      },
    },

    PlanFeaturesLink: {
      fontSize: 13,
      margin: [spacing[4], spacing[5], 0],
      textAlign: 'center',

      [MD_MEDIA_QUERY]: {
        position: 'absolute',
        bottom: spacing[4],
        textAlign: 'left',
      },
    },

    PackageFooterCTA: {
      padding: [0, spacing[4]],
    },
  })
);
